import { callApi } from './ApiClient';

const getCurrentPersonStatus = (data, dispatch) => {
  return callApi('GET', '/current_person_status', data, dispatch);
}

const getPersonStatus = (data, dispatch) => {
  return callApi('GET', '/current_person_status/get_person_status', data, dispatch);
}


export const CurrentPersonStatusApi = {
  getCurrentPersonStatus,
  getPersonStatus,
};



// WEBPACK FOOTER //
// ./src/redux/api/CurrentPersonStatusApi.js